import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {deriveStepUiSchema} from 'pipelines/generalized-step-config-editor/step-config-settings/deriveStepUiSchema';
import {getStepTypeConfigShape} from 'pipelines/StepShapeUtils';

import {StepTypeConfigUISchemaV2} from '../step-config-settings/StepConfigUISchemas';

const DATASETS_TO_PLATES_BASE_UI_SCHEMA = deriveStepUiSchema(
  getStepTypeConfigShape(PipelineStepType.DATASETS_TO_PLATES, 0).fields
);

export const DATASETS_TO_PLATES_V0_UI_SCHEMA = {
  ...DATASETS_TO_PLATES_BASE_UI_SCHEMA,
  plateIdentifierColumn: {
    ...DATASETS_TO_PLATES_BASE_UI_SCHEMA.plateIdentifierColumn,
    displayName: 'Plate identifier column',
  },
} as StepTypeConfigUISchemaV2<PipelineStepType.DATASETS_TO_PLATES, 0>;
